import React from 'react';
import DataGrid, { Column } from 'devextreme-react/data-grid';


class RateEditGrid extends React.Component {
  constructor(props) {
    super(props);
  }


  render() {
    return (
      <React.Fragment>
        <DataGrid
          id="gridContainerSkill"
          dataSource={this.props.rates}
          keyExpr="info.id"
          allowColumnReordering={true}
          showBorders={true}
        >
          <Column caption="Раздел" alignment={'center'} key="section" dataField="data.section" width={100} />
          <Column caption="Критерий" key="name" dataField="data.name"  />
          <Column caption="Удельный вес (%)" alignment={'center'} key="rate" dataField="data.rate" width={150} />
        </DataGrid>
      </React.Fragment>
    );
  }
}

export default RateEditGrid;
